import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Layout from '../Layout';
import SettingsPanel from './SettingsPannel';
import DisplayPannel from './Displaypannel';
import { set } from 'react-hook-form';

const TEKaQR = () => {
  const [displayData, setDisplaydata] = useState()// state to be used for data manipulation
  const [isTextClicked, setIsTextClicked] = useState(false); // State for text click tracking
  const [konvaImage, setKonvaImage] = useState(null); // Store image for Konva
  const [widthInInches, setWidthInInches] = useState(6);
  const [heightInInches, setHeightInInche] = useState(5); // Example height
   // ✅ Default values set to TRUE
   const [isRulerChecked, setIsRulerChecked] = useState(true);
   const [isShowGridChecked, setIsShowGridChecked] = useState(true);
   const [isSnapToGridChecked, setIsSnapToGridChecked] = useState(true);
 // ✅ State to track text formatting (BOLD, ITALIC, UNDERLINE)
 const [textFormatting, setTextFormatting] = useState({});
 const [fontSize, setFontSize] = useState(16); // Default font size
 const [textColor, setTextColor] = useState("#000000"); // ✅ Default color is black
 const [handleSaveAsPDF, setHandleSaveAsPDF] = useState(null);
 const [link, setLink] = useState(null); // State to store the link for the QR code
 const [codeType, setCodeType] = useState(null); // e.g., 'barcode' or 'upc'

  return (
    <Layout>
      <Container style={{ minHeight: '70vh' }} className="py-3 teka-qr">
        <Row className="h-100 row-gap row-reverse">
          <Col md={8}>
            <div className="h-100 p-3 border rounded">
              <DisplayPannel  
              widthInInches={widthInInches} heightInInches={heightInInches}
              isRulerChecked={isRulerChecked} isShowGridChecked={isShowGridChecked}
              isSnapToGridChecked={isSnapToGridChecked}
              konvaImage={konvaImage} isTextClicked={isTextClicked} 
              textFormatting={textFormatting} // ✅ Pass formatting state to DisplayPannel
              fontSize={fontSize} // ✅ Pass font size
              textColor={textColor}  // ✅ Pass textColor 
              setHandleSaveAsPDF={setHandleSaveAsPDF}
              link={link} // Pass the link state to DisplayPannel
              codeType={codeType}
              />
            </div>
          </Col>

          <Col md={4}>
            <div className="h-100 p-3 border rounded">
              <SettingsPanel  
              widthInInches={widthInInches} setWidthInInches={setWidthInInches} 
              heightInInches={heightInInches} setHeightInInche={setHeightInInche}
              isRulerChecked={isRulerChecked} setIsRulerChecked={setIsRulerChecked}
              isShowGridChecked={isShowGridChecked} setIsShowGridChecked={setIsShowGridChecked}
              isSnapToGridChecked={isSnapToGridChecked} setIsSnapToGridChecked={setIsSnapToGridChecked}
              isTextClicked={isTextClicked} setIsTextClicked={setIsTextClicked} 
              KonvaImage={konvaImage} setKonvaImage={setKonvaImage}  
              textFormatting={textFormatting} setTextFormatting={setTextFormatting} // ✅ Pass function to update formatting
              fontSize={fontSize} setFontSize={setFontSize} // ✅ Pass font size state and setter
              textColor={textColor} setTextColor={setTextColor} // ✅ Pass textColor state and setter
              handleSaveAsPDF={handleSaveAsPDF}
              setLink={setLink} // Pass the setLink function to SettingsPanel
              link={link} // Pass the link state to SettingsPanel
              onCodeTypeChange={setCodeType}
               />
            </div>
          </Col>
        </Row>
      </Container>
    </Layout>
  );
};

export default TEKaQR;